import SocialButton from "./SocialButton";

const handleSocialLogin = (user) => {
  console.log(user);
};

const handleSocialLoginFailure = (err) => {
  console.error(err);
};

const FacebookLogin = () => {
  return (
    <div className="facebook-btn login-btn d-sm-inline-block">
      <SocialButton
        provider="facebook"
        appId="YOUR_APP_ID"
        onLoginSuccess={handleSocialLogin}
        onLoginFailure={handleSocialLoginFailure}
      >
        Login with Facebook
      </SocialButton>
    </div>
  )
}

export default FacebookLogin;
